<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_19799_4964)">
			<path
				d="M17.4399 15.1772C16.3139 14.0512 14.816 13.4297 13.2223 13.4297H10.7806C9.18682 13.4297 7.68893 14.0501 6.56288 15.1772C5.43684 16.3043 4.81641 17.8022 4.81641 19.3949V19.7C4.81641 20.2523 5.26412 20.7 5.81641 20.7H18.1864C18.7387 20.7 19.1864 20.2523 19.1864 19.7V19.3949C19.1864 17.8011 18.566 16.3033 17.4399 15.1772Z"
				:fill="props.iconColor"
			/>
			<path
				d="M12.0021 11.5549C14.2774 11.5549 16.1292 9.70313 16.1292 7.42786C16.1292 5.1526 14.2774 3.30078 12.0021 3.30078C9.72682 3.30078 7.875 5.1526 7.875 7.42786C7.875 9.70313 9.72682 11.5549 12.0021 11.5549Z"
				:fill="props.iconColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_19799_4964">
				<rect width="14.37" height="17.3995" :fill="props.iconColor" transform="translate(4.81641 3.30078)" />
			</clipPath>
		</defs>
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffff',
	}
);
</script>

<style lang="scss" scoped></style>
